import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import OnScreen from 'components/OnScreen';

// Polyfill for IE and Safari < 9 

/**
 * Number.isFinite
 * Copyright (c) 2014 marlun78
 * MIT License, https://gist.github.com/marlun78/bd0800cf5e8053ba9f83
 * 
 * Spec: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.isfinite
 */
if (typeof Number.isFinite !== 'function') {
    Number.isFinite = function isFinite(value) {
        // 1. If Type(number) is not Number, return false.
        if (typeof value !== 'number') {
            return false;
        }
        // 2. If number is NaN, +∞, or −∞, return false.
        if (value !== value || value === Infinity || value === -Infinity) {
            return false;
        }
        // 3. Otherwise, return true.
        return true;
    };
}

const formatNumber = num => {
    if(Number.isFinite(num)) num = num.toString();

    return num.replace('.', ',');
};

function generateNumberDifferences(oldValue, newValue, steps = 20) {
    let values = [];

    let diff = oldValue - newValue;

    for(let i = 1; i <= steps; i++) {
        values.push((oldValue - (diff/(steps+1) * i)).toFixed(2));
    }

    return values;
}

class AnimatedNumber extends React.PureComponent {
    static propTypes = {
        children: PropTypes.string,
        className: PropTypes.string,
        onScreen: PropTypes.bool,
        visibleClassName: PropTypes.string,
        prefix: PropTypes.string,
        suffix: PropTypes.string,
        style: PropTypes.object,
    }

    static defaultProps = {
        colors: false
    }

    state = {
        outputValue: null
    }

    componentWillReceiveProps({ onScreen }) {
        if(onScreen) {
            const diffArray = generateNumberDifferences(0, this.props.children, 30),
                width = this.numberEl.offsetWidth;

            this.setState({
                width: width,
                outputValue: this.props.children
            }, () => {
                for(let i = 0; i < diffArray.length; i++)
                    this._setOutputValue(diffArray[i], (i+1) * 25);

                this._setOutputValue(null, (diffArray.length + 1) * 25);
            });
        }
    }

    _setOutputValue(outputValue, timeout) {
        (typeof window !== 'undefined') && window.setTimeout(() => this.setState({ outputValue }), timeout);
    }

    render() {
        const {
            children,
            className,
            onScreen,
            prefix,
            suffix,
            style,
            visibleClassName,
        } = this.props;

        const { outputValue } = this.state;

        let value = children && formatNumber(children);

        if (outputValue) {
            value = formatNumber(outputValue);
        }

        return (
            <span
                className={cn(className, (onScreen && visibleClassName))}
                ref={s => this.numberEl = s}
                style={{
                    ...style,
                    width: this.state.width
                }}
            >
                {`${prefix || ""}${value}${suffix || ""}`}
            </span>
        );
    }
}

export default OnScreen(AnimatedNumber);



// WEBPACK FOOTER //
// ./src/components/AnimatedNumber/AnimatedNumber.jsx